import { faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import http from '../assets/http';

export default class ScheduledPrayerAdmin extends React.Component {
  constructor() {
    super();
    this.state = {
      scheduled: [],
      loading: true,
      deleting: null,
    };
  }

  componentDidMount() {
    this.fetchScheduledPrayers();
  }

  fetchScheduledPrayers = () => {
    let data = new FormData();
    data.set('method', 'get_scheduled_prayers');

    http
      .post('admin.php', data)
      .then(http.processResponse)
      .then((response) => {
        const { ok, res } = response;
        if (ok && res.hasOwnProperty('data')) {
          this.setState({
            scheduled: res.data,
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching scheduled prayers:', error);
        this.setState({ loading: false });
      });
  };

  handleDelete = (dateC) => {
    if (
      !window.confirm(
        `Are you sure you want to delete all scheduled prayer times for ${this.formatDate(
          dateC
        )}?`
      )
    ) {
      return;
    }

    this.setState({ deleting: dateC });

    let data = new FormData();
    data.set('method', 'delete_scheduled_prayer');
    data.set('dateC', dateC);

    http
      .post('admin.php', data)
      .then(http.processResponse)
      .then((response) => {
        const { ok, res } = response;
        if (ok && res.hasOwnProperty('data')) {
          this.setState({
            scheduled: res.data,
            deleting: null,
          });
        }
      })
      .catch((error) => {
        console.error('Error deleting scheduled prayer:', error);
        this.setState({ deleting: null });
      });
  };

  formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  groupByDate = (scheduled) => {
    const grouped = {};
    scheduled.forEach((item) => {
      if (!grouped[item.dateC]) {
        grouped[item.dateC] = [];
      }
      grouped[item.dateC].push(item);
    });
    return grouped;
  };

  render() {
    const groupedScheduled = this.groupByDate(this.state.scheduled);
    const dates = Object.keys(groupedScheduled).sort();

    return (
      <div id='ScheduledPrayer' className='page'>
        <div className='white-bg centerize'>
          <h3 className='noor-h1'>Scheduled Prayer Times</h3>

          {this.state.loading ? (
            <div className='text-center p-4'>
              <FontAwesomeIcon icon={faSpinner} spin size='2x' />
              <p className='mt-2'>Loading scheduled times...</p>
            </div>
          ) : this.state.scheduled.length === 0 ? (
            <div className='alert alert-info text-center'>
              <p className='mb-0'>No upcoming scheduled prayer times.</p>
              <small>
                Use the "Prayer Times" section above to schedule future times by
                selecting a future date.
              </small>
            </div>
          ) : (
            <div className='scheduled-list'>
              {dates.map((dateC) => {
                const isDeleting = this.state.deleting === dateC;
                return (
                  <div key={dateC} className='card mb-3'>
                    <div className='card-header bg-primary text-white d-flex justify-content-between align-items-center'>
                      <strong>{this.formatDate(dateC)}</strong>
                      <button
                        className='btn btn-sm btn-light'
                        onClick={() => this.handleDelete(dateC)}
                        disabled={isDeleting}
                        title='Delete all times for this date'
                      >
                        {isDeleting ? (
                          <FontAwesomeIcon icon={faSpinner} spin />
                        ) : (
                          <FontAwesomeIcon icon={faTrash} />
                        )}
                      </button>
                    </div>
                    <table className='table table-striped table-hover mb-0'>
                      <thead>
                        <tr>
                          <th>Prayer Name</th>
                          <th>Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {groupedScheduled[dateC].map((item) => (
                          <tr key={`${item.timeid}-${item.dateC}`}>
                            <td>{item.prayername}</td>
                            <td className='text-muted'>{item.time}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
}
